export type Id = number | string;
export type IdMap<T> = Record<number, T> | null | undefined;

export const normalizeId = (id: Id | null | undefined): number | null => {
  if (id == null) return null;
  if (typeof id === 'number') return Number.isFinite(id) ? id : null;
  const parsed = Number(id);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getById = <T>(map: IdMap<T>, id: Id | null | undefined): T | undefined => {
  const normalizedId = normalizeId(id);
  if (map == null || normalizedId == null) return undefined;
  return (map as Record<number, T>)[normalizedId];
};

export const getManyByIds = <T>(map: IdMap<T>, ids: Array<Id> | null | undefined): T[] => {
  if (map == null || !ids?.length) return [];
  const resolved: T[] = [];
  for (const id of ids) {
    const value = getById(map, id);
    if (value) resolved.push(value);
  }
  return resolved;
};

